import axios from 'axios';
import { fetchLogin } from './User';
import localStore from '@src/utils/storage';


const apiStore = ( () => {
        const axiosInstance = axios.create( { withCredentials: true } );
        let baseUrl = null, subscriberPath, tokenPath,  params = {};


        const rejectApi = () => Promise.reject( { message : 'no configuration' } );

        axiosInstance.interceptors.request.use( ( request ) => {
            if( !baseUrl ) return rejectApi ;
            
            let relativePath = request.tokenRequest ? tokenPath : subscriberPath ; 
            request.url = relativePath + request.url ;

            if( request.method === 'get' ) request.params = { ...params, ...( request.params ?? {} ) };
            
            //For post request
            if( ( request.method === 'post' )  && ( request.data instanceof FormData ) ) {
                let countryData = '';
                for (const [key, value] of request.data) {

                    if(key == 'country'){
                        countryData = value
                    }

                }

                if(countryData) delete params.country ;

                for( let prop in params ){
                    request.data.append( prop, params[ prop ] );
                }

            } 
            else if (request.method === 'post' && (request.data instanceof Object)) {
                for( let prop in params ){
                    request.data[prop] = params[ prop ];
                }

            }

            if (request.method === 'put' && (request.data instanceof Object)) {

                let countryData = '';

                for (const [key, value] of Object.entries(request.data)) {

                    if(key == 'country'){
                        countryData = value
                    }

                }

                if(countryData) delete params.country ;


                for( let prop in params ){
                    request.data[prop] = params[ prop ];
                }

            }

            if (request.method === 'delete' && (request.data instanceof Object)) {

                for( let prop in params ){
                    request.data[prop] = params[ prop ];
                }

            }
 
            return request ;
        } )

        axiosInstance.interceptors.response.use( ( response ) => {
            return response ;
        }, async ( error ) => {
            const config = error.config ;

            if( error.response.status === 401 && !config.retry_ ){  
                let retry = localStore.get( "allow_autologin" );
                if(localStore.get( "allow_autologin" )) {
                    localStore.remove( "allow_autologin" )
                }
                config.retry_ = true ;
                await fetchLogin( {}, retry , { retry_ : retry } ) ;
                return axios( config ) ;                
            }
            return Promise.reject( error ) ;
        })



        // methods :

        function setBase( paths ){
            baseUrl =  paths.baseUrl ;
            subscriberPath = baseUrl + paths.subscriberPath ;
            tokenPath = baseUrl + paths.tokenPath ;
        }

        function addParams(requestParams) {
            console.log("RequestParams : ",requestParams);
            params = { ...params , ...requestParams };
        }

        return {
            axios: axiosInstance,
            setBase,
            addParams
        }
} )();




export default apiStore ;